
export default {
    name: 'TagsEditorModal',

    data: () => ({
        newTagName: null,
        newTagColor: '#A5A5A5',
        showLoader: false,
    }),

    props: {
        tagAction: {
            type: String,
            required: true,
        },
        editTagName: {
            type: String,
        },
        editTagColor: {
            type: String,
        },
        editTagId: {
            type: String,
        },
    },

    mounted() {
        this.newTagName = this.editTagName;
        if (this.editTagColor) {
            this.newTagColor = this.editTagColor;
        }
    },

    computed: {
        title() {
            return this.tagAction === 'create' ? this.$t('tags.manage.create') : this.$t('tags.manage.edit');
        },

        isFormValid() {
            return this.newTagName && this.newTagColor;
        },
    },

    methods: {
        async writeTag() {
            this.showLoader = true;
            if (this.tagAction === 'create') {
                await this.createTag();
            } else if (this.tagAction === 'edit') {
                await this.editTag();
            }
        },

        async createTag() {
            if (!this.newTagName || !this.newTagColor) {
                return;
            }

            try {
                await this.$store.dispatch('tag/createTag', {
                    name: this.newTagName,
                    color: this.newTagColor,
                });
            } catch (e) {
                console.error(e);
            } finally {
                this.showLoader = false;
            }

            this.$store.commit('ui/hideModal');
        },

        async editTag() {
            console.log(this.newTagName, this.newTagColor, this.editTagId);
            if (!this.newTagName || !this.newTagColor || !this.editTagId) {
                return;
            }

            try {
                await this.$store.dispatch('tag/updateTag', {
                    id: this.editTagId,
                    name: this.newTagName,
                    color: this.newTagColor,
                });
            } catch (e) {
                console.error(e);
            } finally {
                this.showLoader = false;
            }

            this.$store.commit('ui/hideModal');
        },
    },
};
